import {InjectionToken} from "@angular/core";

export const INT_LIST_DISPLAY_DATA_EXTRACTION_PROTECTED_PARAMS_BETWEEN_UPDATES_TOKEN
  = new InjectionToken<Array<string>>('INT_LIST_DISPLAY_DATA_EXTRACTION_PROTECTED_PARAMS_BETWEEN_UPDATES_TOKEN', {
    factory() {
      return [];
    },
})
